import { render, staticRenderFns } from "./GrantTypes.vue?vue&type=template&id=395ca4b3&"
import script from "./GrantTypes.vue?vue&type=script&lang=js&"
export * from "./GrantTypes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports